import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpDataAddress } from '@think-it-labs/edc-connector-client';
import { AmazonS3DataAddress } from '../../models/amazon-s3-data-address';
import { InesDataStoreAddress } from '../../models/ines-data-store-address';
import { StorageType } from '../../models/storage-type';
import { DATA_ADDRESS_TYPES } from '../../utils/app.constants';

@Component({
  selector: 'app-asset-storage-form',
  templateUrl: './asset-storage-form.component.html',
  styleUrls: ['./asset-storage-form.component.scss'],
  standalone: false
})
export class AssetStorageFormComponent {
  readonly noneStorageTypeId = '__NONE__';

  @Input() storageTypes: StorageType[] = [];
  @Input() storageTypeId = '';
  @Output() storageTypeIdChange = new EventEmitter<string>();

  @Input() httpDataAddress: HttpDataAddress = {
    type: 'HttpData'
  };
  @Output() httpDataAddressChange = new EventEmitter<HttpDataAddress>();

  @Input() amazonS3DataAddress: AmazonS3DataAddress = {
    type: 'AmazonS3',
    region: ''
  };
  @Output() amazonS3DataAddressChange = new EventEmitter<AmazonS3DataAddress>();

  @Input() inesDataStoreAddress: InesDataStoreAddress = {
    type: 'InesDataStore'
  };
  @Output() inesDataStoreAddressChange = new EventEmitter<InesDataStoreAddress>();

  @Input() allowNone = false;
  @Input() noneOptionLabel = 'None';
  @Input() allowAmazonS3 = true;
  @Input() allowInesDataStore = true;
  readonly dataAddressTypes = DATA_ADDRESS_TYPES;

  get visibleStorageTypes(): StorageType[] {
    return this.storageTypes.filter(storageType => {
      if (!this.allowAmazonS3 && storageType.id === DATA_ADDRESS_TYPES.amazonS3) {
        return false;
      }

      if (!this.allowInesDataStore && storageType.id === DATA_ADDRESS_TYPES.inesDataStore) {
        return false;
      }

      return true;
    });
  }

  onStorageTypeChange(storageTypeId: string): void {
    this.storageTypeIdChange.emit(storageTypeId);
  }

  onToggleChange(propertyName: keyof HttpDataAddress, enabled: boolean): void {
    this.httpDataAddress[propertyName] = enabled ? 'true' : 'false';
    this.httpDataAddressChange.emit(this.httpDataAddress);
  }

  onInesFilesChange(files: File[]): void {
    if (files?.length > 0) {
      this.inesDataStoreAddress.file = files[0];
    } else {
      delete this.inesDataStoreAddress.file;
    }

    this.inesDataStoreAddressChange.emit(this.inesDataStoreAddress);
  }
}
